import PulseLoader from 'vue-spinner/src/PulseLoader'
import data from './attrs/data'

export default {
    name: 'Loading',
    components: {
        PulseLoader
    },
    data,
    props: ['activeLoading'],
}